export const defaultSignatureFieldHeightPx = 60;
export const defaultSignatureFieldWidthPx = 256;
export const signatureFieldAspectRatio =
  defaultSignatureFieldWidthPx / defaultSignatureFieldHeightPx;
export const minSignatureFieldHeightPx = 16;
export const minSignatureFieldWidthPx = minSignatureFieldHeightPx * signatureFieldAspectRatio;

export const defaultInitialsFieldHeightPx = 60;
export const defaultInitialsFieldWidthPx = 150;
export const initialsFieldAspectRatio = defaultInitialsFieldWidthPx / defaultInitialsFieldHeightPx;
export const minInitialsFieldHeightPx = minSignatureFieldHeightPx;
export const minInitialsFieldWidthPx = minInitialsFieldHeightPx * initialsFieldAspectRatio;

/**
 * Bracket and label geometry shared by every signature/initials frame: the Slate
 * placeholder, the PDF widget chrome, the drag preview, the stamp image baked by
 * `drawFramedSigPreview`, and the caret-extent query `getSignatureFieldLayoutWidthPx`.
 * Everything but the resize handle scales with the widget's width, as the stamp image
 * does once signed. Label widths are measured at 8px system-ui with ~2px of padding
 * for font-rendering variance.
 */
const placeholderLayoutBasePx = {
  bottomLabelWidth: 40,
  bottomStub: 13,
  cornerR: 6,
  handleMargin: 2,
  handleSize: 12,
  labelFontPx: 8,
  labelGap: 3,
  strokeWidthPx: 2,
};

export const initialsPlaceholderLayoutPx = {
  ...placeholderLayoutBasePx,
  topLabelWidth: 30,
  topStub: 111,
};

export const signaturePlaceholderLayoutPx = {
  ...placeholderLayoutBasePx,
  topLabelWidth: 42,
  topStub: 205,
};
